import axios from "axios";

// Models
import LatestInstagramReelDTO from "../Models/DTOs/LatestInstagramReelDTO";

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL ?? "/";

export async function GetLatestAuthorInstagramReel(
    authorId: number,
    abortController: AbortController
): Promise<LatestInstagramReelDTO> {
    const response = await axios.get<LatestInstagramReelDTO>(
        `${WEB_API_URL}v1/authors/${authorId}/instagram/latest-reel`,
        { signal: abortController.signal }
    );

    return response.data;
}
